import {InjectionToken} from '@angular/core';

export const TISA_VIEW_ARTICLE_PATH = new InjectionToken(
  'Provides path to a single article page.',
);
